module.exports = __webpack_public_path__ + "img/undraw_upload_87y9@2x.78c3b8f5.png";